import {abilityFeature} from '../abilityFeature';

/**
 * Validates whether the current publish-modal strategy matches the strategy
 * an ability config opts into. The publish-strategy state is set by the
 * Designer publish modal's segmented toggle ("This page" / "Full site") and
 * lives in `PublishWorkflowStore.publishStrategy`.
 *
 * Strict equality — an ability that requires `strategy: 'page'` is unavailable
 * when the user is in `'site'` mode (and vice versa). Consumers compose this
 * with other dimensions and OR-compose multiple config objects in arrays
 * when the ability should be available in either mode for different reasons.
 */
export const publish = abilityFeature({
  key: 'publish',
  isValid: function isPublishValid(state, config) {
    return state.PublishWorkflowStore.publishStrategy === config.strategy;
  },
});
